import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import RequestAccess from "../../../components/requestAccess/RequestAccess";
import Utils from "../../../utils/Utils";
import Loader from "../../../components/Loader";
import WebUtils from "../../../utils/WebUtils";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import { ROLES } from "../../../constants/UserRoles";
import CVMain from "../../../components/b2bCandidate/cvOptimizer/optimizeResume/CVMain";
import { Segmented } from "antd";
import AllResumesMain from "../../../components/b2bCandidate/cvOptimizer/AllResumesMain";
import OptimizeResume from "../../../components/b2bCandidate/cvOptimizer/OptimizeResume";
import { useSearchParams } from "react-router-dom";
import ReportMain from "../../../components/b2bCandidate/cvOptimizer/report/ReportMain";

function CVOptimizer() {
  const userDetail = Utils.getUserDetail();

  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  const [tab, setTab] = useState(searchParams.get("tab") || "optimizeResume");

  useEffect(() => {
    const urlTab = searchParams.get("tab");

    if (urlTab && urlTab !== tab) {
      setTab(urlTab);
    }
  }, [searchParams]);

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    if (userDetail?.userRole === "JOBDRONA_CANDIDATE") {
      getModuleInfo();
    }
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar
          activePage="cv-optimizer"
          userRole={
            userDetail?.userRole === "JOBDRONA_CANDIDATE"
              ? "candidate"
              : ROLES.b2b_candidate
          }
        />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="cv-optimizer"
            userRole={
              userDetail?.userRole === "JOBDRONA_CANDIDATE"
                ? "candidate"
                : ROLES.b2b_candidate
            }
            newTitle="CV Optimizer"
            noNavigate={true}
          />
          {userDetail?.userRole === "JOBDRONA_CANDIDATE" &&
          !moduleInfo?.hasCvOptimizerAccessGranted ? (
            <RequestAccess moduleName="CV_OPTIMIZER" />
          ) : (
            <div className="px-5">
              <div className="mt-3 flex justify-start items-start overflow-x-auto orange-scroll pb-1">
                <div className="w-full">
                  <Segmented
                    options={[
                      {
                        label: "Optimize Resume",
                        value: "optimizeResume",
                      },
                      {
                        label: "All Resumes",
                        value: "allResumes",
                      },
                      {
                        label: "Resume-Job Match Report",
                        value: "report",
                      },
                    ]}
                    block
                    className="w-[700px]"
                    onChange={(value) => {
                      setTab(value);

                      setSearchParams({
                        tab: value,
                      });
                    }}
                    value={tab}
                  />
                </div>
              </div>

              <div>
                {tab === "optimizeResume" && <OptimizeResume moduleInfo={moduleInfo} />}
                {tab === "allResumes" && (
                  <AllResumesMain setLoading={setLoading} />
                )}
                {tab === "report" && <ReportMain setLoading={setLoading} />}
              </div>
            </div>
          )}
          {/* {moduleInfo?.hasMockTestAccess && <div></div>}
          {moduleInfo?.hasMockTestAccess === false && (
            <RequestAccess moduleName="CV_OPTIMIZER" />
          )} */}
        </div>
      </div>
    </>
  );
}

export default CVOptimizer;
